import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconNames } from '../../common/constants/icon-names';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { ForeignTradePendingDocument } from '../../store/models/foreign-trade.model';
import { PipesModule } from '../../common/pipes/pipes.module';
import { MaterialModule } from '../../material.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-document-pending',
  imports: [CommonModule, MaterialModule, TranslateModule, PipesModule, SvgIconComponent],
  templateUrl: './document-pending.component.html',
  styleUrls: ['./document-pending.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPendingComponent {
  @Input() documents: ForeignTradePendingDocument[];
  notAvailable = NOT_AVAILABLE;
  iconNameList = IconNames;

  columns: string[] = [
    'arrivalDate',
    'clearanceDate',
    'deviationDescription',
    'beginDate',
    'endDate',
    'observation',
    'justification',
    'aimedBy',
    'concludedBy',
    'conclusionEntity',
    'invoice',
    'materialDeviation',
    'deviationOrderItem',
  ];
}
